import { useContext } from 'react';

import { GatsbyImg } from 'components';
import { LocaleContext } from 'components/rebrand/Layout';
import { Link } from 'components/rebrand/Link';

import { IArticleSanityData } from 'typescriptDefs/pages/learn/article';
import { IAuthorSanityData } from 'typescriptDefs/pages/learn/author';

import { getSanityImageUrl } from 'helpers/sanityImageBuilder';

const Avatar = ({ authorData, isGROQ }: { authorData: IAuthorSanityData; isGROQ: boolean }) => {
  if (!authorData.img) return null;
  return isGROQ && authorData.img.url ? (
    <img
      alt={authorData.name}
      src={getSanityImageUrl(authorData.img.url, {
        width: 96,
        height: 96,
      })}
      className="h-56 w-56 rounded-[50%]"
    />
  ) : (
    <GatsbyImg alt={authorData.name} image={authorData.img.asset.gatsbyImageData} className="h-56 w-56 rounded-[50%]" />
  );
};

type Props = {
  authorData: IArticleSanityData['authorData'];
  isGROQ: boolean;
};

export const Authors = ({ authorData, isGROQ }: Props) => {
  const locale = useContext(LocaleContext);
  return (
    <div className="flex flex-row items-center gap-16">
      <Avatar authorData={authorData} isGROQ={isGROQ} />
      <div className="mb-16 sm:mb-0">
        <p className="text-md font-medium text-grey-400">{{ en: `Written By`, fr: `Écrit par` }[locale]}</p>
        <Link
          variant="secondary"
          href={`${authorData.locale === 'fr' ? '/fr' : ''}/author/${authorData.slug.current}/`}
        >
          <p className="text-md font-medium">{authorData.name}</p>
        </Link>
      </div>
    </div>
  );
};
